export function waitForSocketConnection(socket: WebSocket, callback: () => void) {
	if (socket.readyState === WebSocket.OPEN) {
		callback();
	} else {
		const onOpen = () => {
			socket.removeEventListener('open', onOpen);
			callback();
		};
		socket.addEventListener('open', onOpen);
	}
}

export function safeSocketSend(socket: WebSocket | null, message: string) {
	if (!socket) return;

	waitForSocketConnection(socket, () => {
		try {
			socket.send(message);
		} catch (error) {
			console.error('Ошибка при отправке WebSocket:', error);
		}
	});
}
